import React, { Component } from 'react';

class TeamInfo extends Component {
  render() {
    if(this.props.info.address !== null && this.props.info.state !== null){
      return (
        <div>
          <div className="section-title">{this.props.info.full_team_name}</div>
          <div className="teamInfoBox">
            <h4>Team Address</h4>
            <p className="teamAddress no-margin">{this.props.info.address}<br />
              {this.props.info.address2}<br />
              {this.props.info.city}, {this.props.info.state} {this.props.info.zip}
            </p>
          </div>
        </div>
      );
    } else {
      return (
        <div>
          
        </div>
      );
    }
  }
}

export default TeamInfo;
/*
if(this.props.info.address !== null && this.props.info.state !== null){
  return (
    <div>
      <div className="section-title">{this.props.info.full_team_name}</div>
      <div className="teamInfoBox">
        <h4>Team Address</h4>
        <p className="teamAddress no-margin">{this.props.info.address}<br />
          {this.props.info.address2}<br />
          {this.props.info.city}, {this.props.info.state} {this.props.info.zip}
        </p>
      </div>
    </div>
  );
*/
